import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { GoogleBooksModule } from '®shared/google-books';

import { GoogleOnlineResourcesEffects } from './google-online-resources.effects';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([GoogleOnlineResourcesEffects]),
    GoogleBooksModule,
  ],
})
export class OnlineResourceButtonsModule {}
